import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import MoneyInput from '@/components/Inputs/MoneyInput.vue'

interface MinValueConfig {
  min_amount: number | null
  max_amount: number | null
  applies_to: 'cart_total' | 'gift_cards'
  error_message: string
}

type Mode = 'minimum' | 'maximum' | 'range'


export default /*#__PURE__*/_defineComponent({
  __name: 'MinimumValueRule',
  props: {
  ruleConfig: { type: Object, required: true }
},
  emits: ["update"],
  setup(__props, { emit }: { emit: ({
  (e: 'update', config: MinValueConfig, mode: Mode): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const modeOptions = [
  { value: 'minimum', label: 'Minimum' },
  { value: 'maximum', label: 'Maximum' },
  { value: 'range', label: 'Range' }
]

const mode = ref<Mode>('minimum')
const localConfig = ref<MinValueConfig>({
  min_amount: null,
  max_amount: null,
  applies_to: 'cart_total',
  error_message: ''
})

const scopeLabel = computed(() =>
  localConfig.value.applies_to === 'gift_cards' ? 'gift card value in the cart' : 'cart total'
)

function deriveMode(config: MinValueConfig): Mode {
  const hasMin = config.min_amount != null
  const hasMax = config.max_amount != null
  if (hasMin && hasMax) return 'range'
  if (hasMax) return 'maximum'
  return 'minimum'
}

// Derive the mode once per mount (the modal unmounts this component on close,
// so every open re-derives from the saved config). Re-deriving on every
// round-trip would collapse an explicitly chosen Range back to a single-bound
// mode the moment the operator clears one field to re-type it.
const modeInitialized = ref(false)
watch(
  () => props.ruleConfig,
  (newVal) => {
    if (newVal) {
      localConfig.value = { ...localConfig.value, ...(newVal as Partial<MinValueConfig>) }
      if (!modeInitialized.value) {
        mode.value = deriveMode(localConfig.value)
        modeInitialized.value = true
      }
    }
  },
  { immediate: true, deep: true }
)

function onModeChange(next: Mode) {
  mode.value = next
  if (next === 'minimum') {
    if (localConfig.value.min_amount == null) localConfig.value.min_amount = 0
    localConfig.value.max_amount = null
  } else if (next === 'maximum') {
    if (localConfig.value.max_amount == null) localConfig.value.max_amount = 0
    localConfig.value.min_amount = null
  } else {
    if (localConfig.value.min_amount == null) localConfig.value.min_amount = 0
    if (localConfig.value.max_amount == null) localConfig.value.max_amount = localConfig.value.min_amount || 0
  }
  emitUpdate()
}

function onAmountInput(field: 'min_amount' | 'max_amount', value: number | null) {
  localConfig.value[field] = value
  emitUpdate()
}

function emitUpdate() {
  emit('update', { ...localConfig.value }, mode.value)
}

return { __sfc: true,props, emit, modeOptions, mode, localConfig, scopeLabel, deriveMode, modeInitialized, onModeChange, onAmountInput, emitUpdate, MoneyInput }
}

})